export const ACTION_TYPES = {
	FETCH_START: 'FETCH_START',
	FETCH_SUCCESS: 'FETCH_SUCCESS',
	FETCH_ERROR: 'FETCH_ERROR',
	FETCH_CLEAR: 'FETCH_CLEAR',
}
